import { Fragment } from 'react';
import { Formik } from 'formik';
import { Footer } from './Footer';
import { FormContent } from './FormContent';
export function DefaultRecipientsForm(props) {
    const { isEdit, isEqual, initialRecipients, submitError = false, onSubmit } = props;
    const showOverrideAlert = isEdit && !isEqual;
    const initialValues = {
        recipients: initialRecipients,
    };
    const handleSubmit = (data) => {
        onSubmit(data);
    };
    return (<Formik validateOnMount initialValues={initialValues} onSubmit={handleSubmit}>
      <Fragment>
        <FormContent showOverrideAlert={showOverrideAlert}/>
        <Footer showSubmitAlert={submitError}/>
      </Fragment>
    </Formik>);
}
